import React from 'react';

import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    loggedInMembers: number;
    totalMembers: number;
}

const MemberCountDescription = ({ loggedInMembers, totalMembers }: Props) => {
    const { i18next } = useAppContext();

    return loggedInMembers > 0 ? (
        <>
            {`${i18next.t('pbx.loggedin')}: `}
            <span className="text-gray-800">{`${loggedInMembers}/${totalMembers}`}</span>
        </>
    ) : (
        <span className="text-red font-bold">
            {i18next.t('Queue.HandleMembers.NobodyLoggedIn')}
        </span>
    );
};

export default React.memo(MemberCountDescription);
